import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "rtw_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only if user hasn't already accepted
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) setVisible(true);
    } catch (_e) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: true, at: new Date().toISOString() })
      );
    } catch (_e) {
      // ignore storage errors
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[9999] p-3 sm:p-4"
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Informativa cookie"
    >
      <div className="mx-auto max-w-4xl bg-white/60 backdrop-blur-xl border border-white/40 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.35)] rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 ring-1 ring-black/5">
        <div className="flex items-start gap-3 flex-1">
          <div className="shrink-0 w-10 h-10 rounded-full bg-orange-500/20 backdrop-blur-sm border border-orange-300/40 flex items-center justify-center">
            <Cookie className="w-5 h-5 text-orange-700" />
          </div>
          <div className="text-sm text-slate-800 leading-relaxed">
            <p className="font-semibold text-slate-900 mb-1">Cookie tecnici</p>
            <p>
              quandomiserve.it utilizza solo cookie tecnici essenziali al
              funzionamento del sito (login, sessione, preferenze di ricerca).
              Non usiamo cookie di profilazione o di terze parti a fini
              pubblicitari.{" "}
              <a
                href="/cookie-policy"
                className="text-orange-700 hover:text-orange-800 underline font-medium"
                data-testid="cookie-banner-policy-link"
              >
                Leggi la Cookie Policy
              </a>
              .
            </p>
          </div>
        </div>
        <div className="flex sm:justify-end">
          <button
            type="button"
            onClick={handleAccept}
            className="w-full sm:w-auto px-5 py-2.5 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white rounded-lg font-medium shadow-lg shadow-orange-500/20 transition-colors backdrop-blur-sm"
            data-testid="cookie-banner-accept-btn"
          >
            Ho capito
          </button>
        </div>
      </div>
    </div>
  );
}
